import { ResultProcess } from './../masterdata/models/resultProcess';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BBResponseContainer } from '../carrier/response-container';
import { environment } from "../../environments/environment";
import { tap, timeout } from 'rxjs/operators';


@Injectable()
export class  ResultProcessService {

  readonly PROCESSMMDMSERVICE = 'admin/mdm/result-process';

  constructor(private http: HttpClient) {
  }


addProcess(resultProcess: ResultProcess) {
    let url: string = environment.BB_MDMSERVICE_URL + this.PROCESSMMDMSERVICE;
    return this.http.post<BBResponseContainer>(url, resultProcess).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
    }));
}

updateProcess(resultProcess: ResultProcess) {
    let url: string = environment.BB_MDMSERVICE_URL + this.PROCESSMMDMSERVICE;
    return this.http.put<BBResponseContainer>(url, resultProcess).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
    }));
}

getProcessList(): Observable<BBResponseContainer> {
    let url = environment.BB_MDMSERVICE_URL + this.PROCESSMMDMSERVICE;
    return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
        error.url = url;
    }));
}

}
